const state = {
  shopping_cart: {}
}
const getters = {
  shopping_cart: (state) => {
    return state.shopping_cart
  }
}
const mutations = {
  update(state, value) {
    state.shopping_cart = { ...value };
  }
}
const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
